import React, { ReactNode, useMemo } from 'react';
import styled from 'styled-components';

import { useOrdersQuery } from '#/api/queries/orderQueries';
import Button from '#/components/basic/Button/Button';
import { useSelector } from '#/reduxState/store';

import ActiveOrdersTable from './ActiveOrdersTable';
import { useCancelAllOrders } from './cancelAllOrders';

const MobileTop = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
`;

const CancelWrap = styled.div`
  text-align: right;
  padding: 0 0 16px 0;
`;

type Props = {
  marketFilter: string | undefined;
  onSelectOrder: (orderId: string) => void;
  mobileLeftTopBlock?: ReactNode;
};

export default function ActiveOrdersTableWrap({
  onSelectOrder,
  marketFilter,
  mobileLeftTopBlock,
}: Props) {
  const isMobile = useSelector(state => state.screen.isMobile);

  const { data, isLoading } = useOrdersQuery();
  const { cancelAllModalPlaceholder, showCancelAllConfirmation } =
    useCancelAllOrders(marketFilter || false);

  const activeOrders = useMemo(
    () =>
      (data || []).filter(
        order => !marketFilter || order.market === marketFilter
      ),
    [data, marketFilter]
  );

  return (
    <>
      {isMobile && mobileLeftTopBlock && (
        <MobileTop>{mobileLeftTopBlock}</MobileTop>
      )}
      {cancelAllModalPlaceholder}
      <ActiveOrdersTable
        orders={activeOrders}
        isLoading={isLoading}
        onSelectOrder={onSelectOrder}
        onCancelAll={showCancelAllConfirmation}
      />
      {isMobile && (
        <>
          <CancelWrap>
            <Button
              bordered
              color="red"
              onClick={showCancelAllConfirmation}
              disabled={!data?.length}
            >
              Cancel All{marketFilter ? ` ${marketFilter} Orders` : ''}
            </Button>
          </CancelWrap>
        </>
      )}
    </>
  );
}
